import { NgModule } from '@angular/core';
import { DrugLookupComponent } from './drug-lookup.component';
import { AutoCompleteModule, DropDownListModule } from '@syncfusion/ej2-ng-dropdowns';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DrugLookupServiceInterface } from './drug-lookup-service-interface.service';


@NgModule({
    imports: [
        AutoCompleteModule,
        CommonModule,
        DropDownListModule,
        FormsModule
    ],
    declarations: [
        DrugLookupComponent
    ],
    exports: [
        DrugLookupComponent
    ],
  providers: [
    DrugLookupServiceInterface
  ]
})
export class DrugLookupModule { }



// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/widgets/drug-lookup/drug-lookup.module.ts